import { render, staticRenderFns } from "./cardDetailTemplate.vue?vue&type=template&id=3a99d1f4&scoped=true&"
import script from "./cardDetailTemplate.vue?vue&type=script&lang=js&"
export * from "./cardDetailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./cardDetailTemplate.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cardDetailTemplate.vue?vue&type=style&index=1&id=3a99d1f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99d1f4",
  null
  
)

export default component.exports